import useApi from "@/hooks/api/useApi";
import useMapVaults, { type ResponseVaults } from "@/hooks/data/useMapVaults";
import type { SupSingleVaultV3 } from "@/types";

/**
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-26c153fd-96e0-45e8-84c2-ffdeb83974e9?ctx=documentation
 *
 * @param {string | undefined} protocolId
 * @param {boolean} blockLoading
 * @return {{isLoading: boolean, isError: boolean, data?: SupSingleVaultV3[]}}
 */
export default function useProtocolVaults(protocolId: string | undefined, blockLoading: boolean = false) {
  const { data, isLoading, isError, mutate } = useApi<SupSingleVaultV3[], ResponseVaults[]>(
    {
      path: `/protocol/${protocolId}/vaults/`,
      api: "v2",
    },
    {
      enabled: !blockLoading && !!protocolId,
      strategy: "cached",
      select: useMapVaults,
    }
  );

  return {
    data,
    isLoading,
    isError,
    mutate,
  };
}
